import styles from './reward-bounty.module.css';
import { Modal, Button, message, Form } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getSmipleAddress } from '../../utils/index';
import { useState } from 'react';

import { RewardReport } from '../../api/Report';
import { CustomInput } from '../CustomForm';
import Input from 'antd/lib/input/Input';

const RewardBounty = ({
  visible,
  setVisible,
  address,
  platformAddress,
  whiteHatRewards,
  platformRewards,
  serial_number,
  user_id,
  refreshData,
}) => {
  const [whiteHatTxHash, setWhiteHatTxHash] = useState('');
  const [platformTxHash, setPlatformTxHash] = useState('');
  const [form] = Form.useForm()

  const handleOk = async () => {
    try {
      await form.validateFields(['whiteHat', 'platform'])
      const { code } = await RewardReport({ serial_number, whiteHatTxHash, platformTxHash });
      if (code === '10000') {
        message.success('Reward Successful');
        refreshData();
        setVisible(false);
        setWhiteHatTxHash('');
        setPlatformTxHash('');
        form.resetFields()
      }else{
        // message.error(msg);
      }
    } catch (err) {
      console.log(err)
    }
  };
  const handleCancel = () => {
    /**
     * 关闭弹窗
     */
    setVisible(false);
  };

  // copy data
  const onCopy = () => {
    message.success('copy success');
  };

  const whiteHatTxHashChange = (e) => {
    setWhiteHatTxHash(e.target.value);
  };
  const platformTxHashChange = (e) => {
    setPlatformTxHash(e.target.value);
  };

  return (
    <Modal
      open={visible}
      title={'Reward Bounty'}
      onCancel={handleCancel}
      footer={false}
      style={{
        borderRadius: '8px',
        minWidth: '800px',
      }}
      className={'reward-modal-container'}
      closable={false}
      destroyOnClose={true}
      afterClose={() => {
        setWhiteHatTxHash('');
        setPlatformTxHash('');
        form.resetFields()
      }}
    >
      <div className={styles['reward-bounty-container']}>
      <Form
        form={form}
        labelAlign="left"
        labelCol={{
          sm: {span: 8},
          md: {span: 6},
          lg: {span: 6},
          xl: {span: 6},
          xxl: {span: 6},
        }}
      >
        <Form.Item
        label="WhiteHat Wallet"
        style={{
          lineHeight:'50px',
        }}
        >
          <b>{whiteHatRewards.toLocaleString(navigator.language)} USDC</b>
          <span style={{
            color: '#6ee6c6'
            }
          }>{ '  |  ' }</span>
          {getSmipleAddress(address)}
          <CopyToClipboard text={address} onCopy={onCopy}>
          <span className={styles['copy-button']}> [ COPY ] </span>
          </CopyToClipboard>
        </Form.Item>

        <Form.Item
        label="Platform Wallet"
        style={{
          lineHeight:'50px',
        }}
        >
          <b>{platformRewards.toLocaleString(navigator.language)} USDC</b>
          <span style={{
            color: '#6ee6c6'
            }
          }>{ '  |  ' }</span>
          {getSmipleAddress(platformAddress)}
          <CopyToClipboard text={platformAddress} onCopy={onCopy}>
          <span className={styles['copy-button']}> [ COPY ] </span>
          </CopyToClipboard>
        </Form.Item>

        <Form.Item
          label="WhiteHat Payment TxHash"
          name={"whiteHat"}
          style={{
            lineHeight:'50px',
          }}
          rules={[{required: true}]}
        >
          <Input type="text" onChange={whiteHatTxHashChange} placeholder={"https://etherscan.io/tx/..."} style={{maxWidth: '500px'}}/>
        </Form.Item>

        <Form.Item
          label="Platform Payment TxHash"
          name={"platform"}
          style={{
            lineHeight:'50px',
          }}
          rules={[{required: true}]}
        >
          <Input type="text" onChange={platformTxHashChange} placeholder={"https://etherscan.io/tx/..."} style={{maxWidth: '500px'}}/>
        </Form.Item>

      </Form>
      </div>
      <div className={styles['footer-button']}>
        <Button
          className={styles['button-confirm']}
          onClick={handleOk}
          type="primary"
          style={{
            height: '32px',
            backgroundColor: '#18EAC4',
            borderColor: '#18EAC4',
            color: '#333',
            borderRadius: '6px',
            width: '140px',
          }}
        >
          Confirm Payment
        </Button>
        <Button
          className={styles['button-cancel']}
          onClick={handleCancel}
          // type="primary"
          style={{
            height: '32px',
            // backgroundColor: '#faad14',
            borderColor: '#fff',
            color: '#fff',
            borderRadius: '6px',
            width: '140px',
          }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default RewardBounty;
